export const RESET_USER = 'reset_user';
export const RESET_USER_SUCCESSFUL = 'reset_user_successfull';

export const RESET_PASSWORD_API_FAILED = 'RESET_PASSWORD_API_FAILED';